import { useRef } from 'react';
import { createFeatureFlagStore } from "../../store";
import FeatureFlagContext from "../context/FeatureFlagContext";
import transformBasicFlagToFlagObject from "../utils/transformBasicFlagToFlagObject";
import { jsx as _jsx } from "react/jsx-runtime";
export var FeatureFlagProvider = function FeatureFlagProvider(_ref) {
  var _ref$flags = _ref.flags,
    flags = _ref$flags === void 0 ? [] : _ref$flags,
    organizationId = _ref.organizationId,
    children = _ref.children;
  var storeRef = useRef();
  if (!storeRef.current) {
    storeRef.current = createFeatureFlagStore({
      organizationId: organizationId
    });
    if (flags.length > 0) {
      var transformedFlags = transformBasicFlagToFlagObject(flags);
      storeRef.current.getInitialState().fetchAllFlags(transformedFlags);
    }
  }
  return /*#__PURE__*/_jsx(FeatureFlagContext.Provider, {
    value: storeRef.current,
    children: children
  });
};